import { ApiRoutes, QueryError } from '../../../common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '../../../common/services';
import { DomainRegistrarAccountFormFields } from '../domainRegistrars.interfaces';
import { DomainRegistrarAccount } from '../entities/DomainRegistrarAccount.entity';
import { DomainRegistrarAccountsQueryKeys } from './domain-registrars.keys';

export const useGetPasswordForDomainRegistrarAccountsMutation = (domainRegistrarId: string, domainRegistrarAccountId: string) =>
  buildQuery<Pick<DomainRegistrarAccount, 'password'>, QueryError>(
    [DomainRegistrarAccountsQueryKeys.ShowPassword, domainRegistrarId, domainRegistrarAccountId],
    async () => {
      const { data } = await apiExecutor.get<Pick<DomainRegistrarAccount, 'password'>>(
        ApiRoutes.DomainRegistrarsByIdAccountPassword.replace(':domainRegistrarId', domainRegistrarId).replace(
          ':domainRegistrarAccountId',
          domainRegistrarAccountId,
        ),
      );
      return data;
    },
  );

export const useGetAllDomainRegistrarAccountsQuery = (domainRegistrarId: string) =>
  buildQuery<DomainRegistrarAccount[], QueryError>([DomainRegistrarAccountsQueryKeys.GetAll, domainRegistrarId], async () => {
    const { data } = await apiExecutor.get<DomainRegistrarAccount[]>(
      ApiRoutes.DomainRegistrarsByIdAccounts.replace(':domainRegistrarId', domainRegistrarId),
    );
    return data;
  });

export const useCreateDomainRegistrarAccountsMutation = (domainRegistrarId: string) =>
  buildMutation<DomainRegistrarAccount, QueryError, DomainRegistrarAccountFormFields>(
    [DomainRegistrarAccountsQueryKeys.Create, domainRegistrarId],
    async (postData) => {
      const { data } = await apiExecutor.post<DomainRegistrarAccount>(
        ApiRoutes.DomainRegistrarsByIdAccounts.replace(':domainRegistrarId', domainRegistrarId),
        {
          ...postData,
          domainRegistrarId,
        }, { params: { teamId: localStorage.getItem('currentTeamId') } }
      );
      return data;
    },
  );

export const useEditDomainRegistrarAccountsMutation = (domainRegistrarId: string) =>
  buildMutation<DomainRegistrarAccount, QueryError, DomainRegistrarAccountFormFields>(
    [DomainRegistrarAccountsQueryKeys.Edit, domainRegistrarId],
    async (postData) => {
      const { data } = await apiExecutor.post<DomainRegistrarAccount>(
        ApiRoutes.DomainRegistrarsByIdAccounts.replace(':domainRegistrarId', domainRegistrarId),
        {
          ...postData,
          domainRegistrarId,
        },
      );
      return data;
    },
  );

export const useDeleteDomainRegistrarAccountsMutation = (domainRegistrarId: string) =>
  buildMutation<void, QueryError, string>([DomainRegistrarAccountsQueryKeys.Delete, domainRegistrarId], async (accountId) => {
    const { data } = await apiExecutor.delete<void>(
      ApiRoutes.DomainRegistrarAccountsById.replace(':domainRegistrarId', domainRegistrarId).replace(
        ':domainRegistrarAccountId',
        accountId,
      ),
    );
    return data;
  });

export const useAutocompleteDomainRegistrarAccountsMutation = () =>
  buildMutation<Pick<DomainRegistrarAccount, 'id' | 'login'>[], QueryError, string>(
    [DomainRegistrarAccountsQueryKeys.Autocomplete],
    async (domainRegistrarId) => {
      const { data } = await apiExecutor.get<Pick<DomainRegistrarAccount, 'id' | 'login'>[]>(
        ApiRoutes.DomainRegistrarsByIdAccountsAutocomplete.replace(':domainRegistrarId', domainRegistrarId),
      );
      return data;
    },
  );
